export const toAccountLogin = (
  returnUrl: string,
  params: Record<string, any> = {}
) => {
  const url = new URL(window.location.origin + '/account/login');
  url.searchParams.append('returnUrl', encodeURIComponent(returnUrl));
  for (const [key, value] of Object.entries(params)) {
    if (value != null) {
      url.searchParams.append(key, String(value));
    }
  }
  window.location.href = url.href;
};
